exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ref {\n  margin: 18px 0;\n  background: #89BF55;\n  text-align: center;\n  padding: 5px 12px;\n  height: 32px;\n  width: 32px;\n  border-radius: 50%;\n  color: white;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/form/form/commerce-references-form/commerce-references-form.component.scss
// module id = 931
// module chunks = 0